import getStore from "../store/store";
import { mutatorAction } from "satcheljs";

const setBackgroundImageMutator: (image: string | undefined) => void = mutatorAction("setAppBackgroundImage", (image: string | undefined): void => {
    getStore().image = image;
});
export default setBackgroundImageMutator;
